<template>
  <div class="product bps" v-bind:class="{contrasted: isPageContrasted, fontBigger: isFontBigger}">
    <header class="page-header" data-aos="fade-up">
      <div class="container">
        <div class="heading-text" data-aos="fade-up" v-if="lang === 'pl'">Grant PBE - Pomorski Broker Eksportowy</div>
        <div class="heading-text" data-aos="fade-up" v-if="lang !== 'pl'">Project PBE Grant - Pomorski Broker
          Eksportowy
        </div>
        <p data-aos="fade-up" data-aos-delay="100"></p>
        <span class="line" data-aos="zoom-in-left" data-aos-delay="150"></span>
        <p data-aos="fade-up" data-aos-delay="200"></p>
      </div>
    </header>

    <div id="top" class="why-us-solution">
      <div class="elements">
        <div class="element bps clearfix">
          <div class="text-box">
            <ul v-if="lang === 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
           Grant PBE ("Pomorski Broker Eksportowy") ma na celu promocję Bioseco, jako wystawcy, w 4 międzynarodowych targach i wystawach do 31.03.2023 r. Udział w renomowanych międzynarodowych imprezach wystawienniczych przyczyni się do zmiany modelu biznesowego Bioseco SA, a w konsekwencji przełoży się na wzrost eksportu innowacyjnych systemów detekcji wizyjnej
<br /><br/>
Celem zrealizowanego projektu była promocja firmy Bioseco, jako wystawcy, w 4 międzynarodowych targach i wystawach w terminie do 31.03.2023 roku. Przedstawiciele spółki wzięli udział w 6 wydarzeniach wystawienniczych.
Realizacja projektu pozwoliła na zaprezentowanie oferty produktowej Bioseco w ważnych z punktu widzenia ekspansji wydarzeniach. Przedstawiciele spółki zaprezentowali nie tylko marketingowe aspekty rozwiązania, ale także podjęli wysiłek eksperckiego potwierdzenia skuteczności oferowanych rozwiązań.
Zrealizowane działania były zgodne z polityką internacjonalizacji Bioseco, poprzez efektywne połączenie działalności promocyjnej z elementem budowania pozycji eksperta branżowego, wspieranym przez udział przedstawicieli firmy w panelach dyskusyjnych i prezentacjach.
<br/><br/>
Projekt Grant PBE ("Pomorski Broker Eksportowy") jest współfinansowany z Unii Europejskiej. <br />Numer umowy: UDG-PBE.06.2022/051
                </span>
              </li>
              <li>
                <span class="text">
                  <br/><br/><br/>
                  Kwota dofinansowania z UE:<br/>
                  80 000.00PLN 49,14%
                </span>
              </li>
            </ul>
            <ul v-if="lang !== 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
              Project PBE Grant („Pomorski Broker Eksportowy”) aims to promote Bioseco, as an exhibitor, in 4 international fairs and exhibitions until 31.03.2023. Participation in renowned international exhibition events will contribute to a change in the business model of Bioseco SA and, as a result, will translate into increased exports of innovative vision detection systems
<br/><br/>
The aim of the project was to promote Bioseco, as an exhibitor, in 4 international fairs and exhibitions by 31.03.2023. Delegates of the company participated in 6 exhibition events.
The implementation of the project enabled the Bioseco’s portfolio to be presented at key wind industry events. Representatives of the company presented not only the marketing aspects of the solution, but also made an effort to expertly confirm the effectiveness of the BPS.
The realized activities were in line with Bioseco's internationalization policy, by effectively combining promotional activities with the element of building the position of an industry expert, supported by the participation of company representatives in discussions and presentations.
<br/><br /><br />Project PBE Grant („Pomorski Broker Eksportowy”) is co-financed from the European Union.
                  <br />Agreement number: UDG-PBE.06.2022/051
                </span>
              </li>
              <li>
                <span class="text"><br/><br/><br/>
                  Amount of founding from UE:<br/>
                  80 000.00PLN  49,14%
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store/store';
import FooterMain from '../components/FooterMain';
import FooterMoreInformation from '../components/FooterMoreInformation';
import VideoBox from '../components/VideoBox';
import Counter from '../components/Counter';
import smoothScroll from '../helpers/SmoothScroll';

export default {
  name: 'farms-product',
  components: {
    FooterMain,
    FooterMoreInformation,
    VideoBox,
    Counter
  },
  data: function () {
    return {
      circleValues: [
        {
          before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
          val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
          after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter'),
        },
        {
          before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
          val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
          after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter'),
        },
        {
          before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
          val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
          after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter'),
        },
        {
          before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
          val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
          after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter'),
        },
      ]

    }
  },
  computed: {
    lang: () => {
      return store.state.lang;
    },
    isPageContrasted() {
      return store.state.isPageContrasted
    },
    isFontBigger() {
      return store.state.isPageFontBigger
    },
    smoothScroll: () => smoothScroll
  },

  methods: {},
  mounted: function () {
    store.state.isAccessibilityVisible = true;
  },
  destroyed: function () {
    store.state.isAccessibilityVisible = false;
  },
}
</script>

<style>
.bps header.page-header .heading-text {
  max-width: 1200px !important;
}

.product .why-us-solution .elements .element.bps .text-box {
  float: left;
  max-width: initial;
  margin-top: 20px;
  margin-bottom: 100px;
}

.product .why-us-solution .elements .element.bps .text-box ul li .text {
  margin-top: -20px;
}


.ue {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  text-align: center;
}

.ue img {
  max-width: 940px;
  width: 35%;
}

.product.contrasted {
  background: #000;
  color: yellow;
}

.product.contrasted .heading-text {
  color: yellow;
}

.product.contrasted .ue {
  background: #000;
}

.product.contrasted header a {
  color: yellow;
  background: #000;
}

.product.contrasted .btn {
  color: yellow;
  background: #000;
}

.product.fontBigger .why-us-solution .elements .element .text-box ul li .text {
  font-size: 1.6em;
  line-height: 1.6em;
}


</style>



// WEBPACK FOOTER //
// PBE.vue?d5c476cc